module.exports = __webpack_public_path__ + "static/media/bouncing-arrow.8a79a8c6.svg";